interface ILeaseholdMapColors {
    fillColor: Array<number>;
}

// Rotating palette for top WI owners (assigned dynamically by frequency).
// Yellow is reserved for client-owned acreage and is not part of this palette.
var LeaseholdOwnerPalette: Array<ILeaseholdMapColors> = Array(
    { fillColor: [31, 120, 180, 0.5] },   // Blue
    { fillColor: [227, 26, 28, 0.5] },    // Red
    { fillColor: [51, 160, 44, 0.5] },    // Green
    { fillColor: [255, 127, 0, 0.5] },    // Orange
    { fillColor: [106, 61, 154, 0.5] },   // Purple
    { fillColor: [177, 89, 40, 0.5] },    // Brown
    { fillColor: [166, 206, 227, 0.5] },  // Light Blue
    { fillColor: [178, 223, 138, 0.5] },  // Light Green
    { fillColor: [251, 154, 153, 0.5] },  // Light Red
);

var UnleasedColor: Array<number> = [255, 150, 150, 0.5]; // Salmon/Light Red
var DefaultColor: Array<number> = [80, 80, 80, 0.2];     // Gray
var ClientOwnedColor: Array<number> = [255, 255, 51, 0.5]; // Yellow — reserved for client-owned acreage

export { LeaseholdOwnerPalette, UnleasedColor, DefaultColor, ClientOwnedColor };
export default LeaseholdOwnerPalette;



// WEBPACK FOOTER //
// ./src/components/project/sections/GISComponents/DefaultLeaseholdMapColors.ts